import { successBox } from '@core/components/AlertBox';
import { useAppDispatch } from '@core/redux/hooks';
import { ParentSelectAutocomplete } from '@elements/components/ElementDialog/ElementDialog';
import { elementThunks } from '@elements/redux';
import { SplineElement } from '@elements/types';
import { Button, List, ListItem, ListItemText } from '@mui/material';
import { viewer3dSelectors } from '@viewer3D/redux';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { setSelectedPointIds, setSelectedSplineElements } from './state';
export const ElementSelectionAreaDetails = ({
  splineElements,
}: {
  splineElements: SplineElement[];
}) => {
  const dispatch = useAppDispatch();
  const [selectedParentId, setSelectedParentId] = useState<string | null>(null);
  const projectId = useSelector(viewer3dSelectors.selectedProjectId);
  const [isLoading, setIsLoading] = useState(false);

  const updateElement = async (splineElement: SplineElement) => {
    const { payload } = await dispatch(
      elementThunks.patch({
        path: ['projects', projectId!, 'splineElements', splineElement!.id],
        body: splineElement,
      }),
    );
    return payload as SplineElement;
  };

  const onSubmit = async () => {
    if (!selectedParentId) return;
    setIsLoading(true);

    for (const element of splineElements) {
      const updatedElement = { ...element, parentPointElementId: selectedParentId };
      await updateElement(updatedElement);
    }
    setIsLoading(false);
    setSelectedParentId(null);
    setSelectedSplineElements([]);
    setSelectedPointIds([]);
    successBox('Parent node assigned successfully');
  };

  return (
    <>
      <List dense sx={{ padding: 2 }}>
        <>
          <ParentSelectAutocomplete
            elementToUpdate={splineElements[0]}
            updateProp={(key, val) => {
              setSelectedParentId(val);
            }}
          />

          <ListItem>
            <ListItemText primary={`Selected Elements (${splineElements.length})`} />
          </ListItem>
          {splineElements.map((element) => (
            <ListItem key={element.id}>
              <ListItemText primary={element.name} />
            </ListItem>
          ))}
          <Button
            fullWidth
            variant="outlined"
            sx={{ marginTop: 1 }}
            onClick={onSubmit}
            disabled={isLoading}
          >
            {isLoading ? 'Assigning parent node...' : 'Assign parent node'}
          </Button>
        </>
      </List>
    </>
  );
};
